const servers = {
  //PRO
  "empleo.upm.es": "https://gestion-empleo.upm.es",
  "practicas.upm.es": "https://gestion-practicas.upm.es",
  //PRE
  "portal-upm.dev.doubledot.es": "https://sandbox-upm.dotia.es",
  //gestion economica
  "portal-upm-ge.dev.doubledot.es": "https://sandbox-upm.dotia.es",
  //seguro de practicas (tpv_alumnos)
  "portal-upm-tpv.dev.doubledot.es": "https://sandbox-upm.dotia.es",
  //LOCAL
  "localhost:8080": "https://sandbox-upm.dotia.es",//"https://localhost:44379"
  // "localhost:8080": "https://gestion-practicas.upm.es/"
};

export default servers;


// WEBPACK FOOTER //
// ./src/servers/index.js